<script setup>
import { RouterView } from 'vue-router';
import { onMounted} from 'vue';
import { instalarHeaderFooter } from 'https://arpen-header-footer-homolog.codebit.biz/header-footer.min.js';
import { useAuthStore } from '@/stores/auth';
import helpers from '@/helpers';

const authStore = useAuthStore();

onMounted(async () => {
  console.log(authStore.grupoUsuario);
  instalarHeaderFooter({
    usuario: {
      nome: authStore?.user?.name,
      cpf: authStore?.user?.cpf ? helpers.formatarCPF(authStore.user.cpf) : null,
      grupos: authStore?.grupoUsuario,
      foto: "",
    },
    urlLogin: authStore?.urlLogin(),
    urlLogout: authStore?.urlLogout(),
    token: authStore?.getToken(),
  });
});
</script>

<template>
  <div id="appContainer">
    <div id="header"></div> 
    <span v-if="!authStore.grupoUsuario.includes('Registrador Civil')">
      <div class="container text-center">
        <br /><br />
        
        <SerpTipography type="t3" tag="h3" class="col-span-8" style="font-size:40px; color:#666666;">
          Atenção
        </SerpTipography>
        <br /><br />
        <small>Usuário sem permissão para o acesso ao sistema</small>

        <br /><br /><br /><br />
      </div>
    </span>
    <span v-else>
      <RouterView />
    </span>  
    <div id="footer"></div>
  </div>
</template>


<style scoped>
#main {
  min-height: 84vh;
} 
</style>

<style scoped lang="scss">
@import 'https://arpen-header-footer-homolog.codebit.biz/header-footer.css';
</style>